import { useAllowedStatuses } from "#/hooks/useAllowedStatuses";
import { sanitizeItemStatusLabel } from "#/utils/StringUtils";
import { Select, type SelectProps } from "@mantine/core";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export type Props = Omit<SelectProps, "data">;

/**
 * Status picker fed by the client's allowed statuses — the single list every
 * status field in the app selects from. Use instead of a bare Mantine Select so
 * the options stay consistent wherever a status is chosen.
 */
const ItemStatusSelect = ({ label, placeholder, ...props }: Props) => {
  const { t } = useTranslation();
  const allowedStatuses = useAllowedStatuses();

  const options = useMemo(
    () =>
      allowedStatuses.map((status) => ({
        value: status,
        label: sanitizeItemStatusLabel(status),
      })),
    [allowedStatuses]
  );

  return (
    <Select
      label={label ?? t("common.status")}
      placeholder={placeholder ?? t("common.selectStatus")}
      data={options}
      searchable
      {...props}
    />
  );
};

export default ItemStatusSelect;
